/** Plan detail tab registry — feature_key must match backend feature_setting. */
export const PLAN_DETAIL_TABS = [
  { featureKey: "plan_tab_scope", tabId: "scope", label: "Scope" },
  { featureKey: "plan_tab_task", tabId: "testplan", label: "Task" },
  { featureKey: "plan_tab_testcase", tabId: "testcase", label: "Test Case" },
  { featureKey: "plan_tab_testrun", tabId: "testrun", label: "Test Run" },
  { featureKey: "plan_tab_testreport", tabId: "testreport", label: "Test Report" },
];

export function filterPlanDetailTabs(featureKeys) {
  const allowed = new Set(featureKeys || []);
  const filtered = PLAN_DETAIL_TABS.filter((t) => allowed.has(t.featureKey));
  return filtered.length ? filtered : [...PLAN_DETAIL_TABS];
}

export function isPlanTabAllowed(tabId, featureKeys) {
  const tab = PLAN_DETAIL_TABS.find((t) => t.tabId === tabId);
  if (!tab) return true;
  if (!Array.isArray(featureKeys) || !featureKeys.length) return true;
  return featureKeys.includes(tab.featureKey);
}

export function defaultPlanTabId(featureKeys) {
  const tabs = filterPlanDetailTabs(featureKeys);
  if (tabs.some((t) => t.tabId === "scope")) return "scope";
  return tabs[0]?.tabId || "scope";
}
